import { combineLatest, Observable, of } from 'rxjs';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocationDetails } from 'app/shared/models/location-details';
import { MapService } from 'app/shared/services/map.service';
import { BehaviorSubject, Subscription } from 'rxjs';

import { MonitorSettingsComponent } from '../../../shared/components/map';
import {
    CompositeLocComponent,
    CompositeLocComponentInput,
    CompositeLocCreateInput,
    CompositeLocEditInput,
} from '../../../shared/components/map/composite-loc/composite-loc.component';
import { FilterDataSource } from 'app/shared/data/filter-data-source';
import { CustomerLocationDetail } from '../../../shared/models/customer-location-detail';
import { LocationGroup } from '../../../shared/models/location-group';
import { MonitorAddLocationSelectable, MonitorIdentifier } from '../../../shared/models/monitorsetting';
import { CustomerDetailLocationService } from '../../../shared/services/customer-detail-location.service';
import { StatusCodeService } from '../../../shared/services/status-code.service';
import { UiUtilsService } from '../../../shared/utils/ui-utils.service';
import { LocationWetDryOverflowComponent, LocationWetDryOverflowComponentInput } from '../../../shared/components/location-wet-dry-overflow/location-wet-dry-overflow.component';
import { CustomerService } from 'app/shared/services/customer.service';
import { LocationGroupService } from 'app/shared/services/location-group.service';
import { LocationDashboardService } from 'app/shared/services/location-dashboard.service';
import { GetAllRainGaugesParams, activeInactiveLocationQueryParam, customerEditorQueryParam, customerQueryParam } from 'app/shared/models/customer';
import { LocationStatus, RainLocation } from 'app/shared/models/locations';
import { catchError, debounceTime, distinctUntilChanged, first, map, switchMap, tap } from 'rxjs/operators';
import { GISService } from 'app/shared/services/gis-service';
import { DomOperationUtilsService } from 'app/shared/utils/dom-operation-utils.service';
import { LocationCardService } from 'app/shared/components/location-card/services/location-card.service';
import { MonitorSeries } from 'app/shared/components/location-card/location-card.constants';
import { TrackBy } from 'app/shared/utils/track-by';
import { LocationCardContainerDialogComponent } from 'app/shared/components/location-card/components/location-card-container/location-card-container.component';
import { IComponentModalResult } from 'app/shared/models/modal';
import { LocationCardData } from 'app/shared/components/location-card/models/location-card.model';
import { RAIN_GAUGE } from 'app/shared/constant';
import { PageEvent } from '@angular/material/paginator';
import { CustomerEditorPaginationState } from '../customer-editor-footer.model';
import { UsersService } from 'app/pages/admin/users.service';

interface UISelector<T> {
    value: T;
    text: string;
}

// Rain gauges IDs for #21927
const rainAlertIds = [3, 29];

@Component({
    selector: 'app-customer-detail-locations-editor',
    templateUrl: './customer-detail-locations-editor.component.html',
    styleUrls: ['./customer-detail-locations-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDetailLocationsEditorComponent implements OnInit, OnDestroy {
    @Output() public paginationStateChange = new EventEmitter<CustomerEditorPaginationState>();

    public locationIdEdited: number;
    public locationDataSourceNew: FilterDataSource<CustomerLocationDetail>;
    public assignedRainGauge = new Array<CustomerLocationDetail>();
    public displayFilters: boolean;
    public customerDtlLocEdtrColumns = [
        'locationName',
        'monitorSeries',
        'serialNumber',
        'description',
        'sensors',
        'locationGroupName',
        'status',
        'activeMonitor',
        'locationTypeID',
        'wdo',
        'editLoc',
    ];
    public customerDtlLocEdtrDataSource = new MatTableDataSource();
    public monitorSeriesList: MonitorAddLocationSelectable[];
    public locationGroupList: UISelector<string>[];
    public activeInactiveList: UISelector<string | boolean>[];
    public sensorsList: string[];
    public wdoList: UISelector<string>[];
    public includeInactiveLocations: boolean;
    public compositeList: { value: string; text: string }[];
    public customerId: number;
    private subscriptions = new Array<Subscription>();
    public isLoading = true;
    public locationDataChange: BehaviorSubject<CustomerLocationDetail[]> = new BehaviorSubject<CustomerLocationDetail[]>([]);
    public customerLocations = new Array<CustomerLocationDetail>();
    public initialcustomerLocationsData = new Array<CustomerLocationDetail>();
    public searchedcustomerLocationsData = new Array<CustomerLocationDetail>();
    public isSearchActive: boolean;
    public disableAddLocationBtn: boolean;
    public searchText: string;

    @ViewChild(MatPaginator) public userPaginator: MatPaginator;
    @ViewChild(MatSort) public customerSort: MatSort;
    public totalPaginationLength: number;

    public locationFilterColumns = [
        'locationName',
        'monitorSeries',
        'serialNumber',
        'description',
        'sensors',
        'locationGroupName',
        'status',
        'activeMonitor',
        'locationTypeID',
        'wdo',
        'editLoc',
    ];

    /** Reprsents customer search input */
    public searchString = new FormControl();
    public selectedMonitorSeries: string;
    public selectedActiveLocation = true;
    public selectedwdo: string;
    public selectedSensors: string[];
    public selectedComposite: string;
    public selectedLocationGrp: string;
    public rainGaugesList: RainLocation[] = [];
    public availableRainGauges: RainLocation[] = [];
    /** Represents a collection of location groups, associative flat array */
    private locationGroupsFlat?: { [key: number]: string[] };
    public activateState = false;
    public isSecondMontoringPoint: boolean;
    public dismissText: string;
    public locationUpdateSuccess: string;
    public locationUpdateError: string;
    public cid: number;
    public allTest: string;
    public naTest: string;
    public noTest: string;
    public yesTest: string;
    public activeTest: string;
    public inActiveTest: string;
    public tritonTest: string;
    public echoTest: string;
    public rainTest: string;
    public usgsTest: string;
    public translateKeys: Array<string> = [
        'COMMON.DISMISS_TEXT',
        'COMMON.LOCATION_UPDATE_MESSAGE',
        'COMMON.LOCATION_UPDATE_ERROR',
        'COMMON.TEST_ALL',
        'COMMON.TEST_NA',
        'COMMON.TEST_NO',
        'COMMON.TEST_YES',
        'COMMON.TEST_ACTIVE',
        'COMMON.TEST_INACTIVE',
        'COMMON.TEST_TRI',
        'COMMON.TEST_ECHO',
        'COMMON.TEST_RAIN',
        'COMMON.TEST_USGS',
    ];

    LocationStatus = LocationStatus;
    public locationStatuses: string[] = [];
    public trackByValue = TrackBy.byValue();
    public trackByIndex = TrackBy.byIndex;
    constructor(
        private customerService: CustomerService,
        private dialog: MatDialog,
        private statusCodeService: StatusCodeService,
        private customerLocationService: CustomerDetailLocationService,
        private uiUtilsService: UiUtilsService,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private locationGroupService: LocationGroupService,
        private mapService: MapService,
        private snackBar: MatSnackBar,
        private translate: TranslateService,
        private locationDashboardService: LocationDashboardService,
        private gisService: GISService,
        private domOperationUtilsService: DomOperationUtilsService,
        private locationCardService: LocationCardService,
        private usersService: UsersService,
    ) {
        /*  Search by user email address changes  */
        translate.get(this.translateKeys).subscribe((translateValues) => {
            this.dismissText = translateValues['COMMON.DISMISS_TEXT'];
            this.locationUpdateSuccess = translateValues['COMMON.LOCATION_UPDATE_MESSAGE'];
            this.locationUpdateError = translateValues['COMMON.LOCATION_UPDATE_ERROR'];
            this.allTest = translateValues['COMMON.TEST_ALL'];
            this.naTest = translateValues['COMMON.TEST_NA'];
            this.noTest = translateValues['COMMON.TEST_NO'];
            this.yesTest = translateValues['COMMON.TEST_YES'];
            this.activeTest = translateValues['COMMON.TEST_ACTIVE'];
            this.inActiveTest = translateValues['COMMON.TEST_INACTIVE'];
            this.tritonTest = translateValues['COMMON.TEST_TRI'];
            this.echoTest = translateValues['COMMON.TEST_ECHO'];
            this.rainTest = translateValues['COMMON.TEST_RAIN'];
            this.usgsTest = translateValues['COMMON.TEST_USGS'];
        });


        this.locationStatuses[LocationStatus.Active] = this.translate.instant('CUSTOMER_EDITOR.LOCATION_STATUSES.ACTIVE');
        this.locationStatuses[LocationStatus.Maintenance] = this.translate.instant('CUSTOMER_EDITOR.LOCATION_STATUSES.MAINTENANCE');
        this.locationStatuses[LocationStatus.Inactive] = this.translate.instant('CUSTOMER_EDITOR.LOCATION_STATUSES.INACTIVE');
        this.locationStatuses[LocationStatus.InactiveRemoved] = this.translate.instant('CUSTOMER_EDITOR.LOCATION_STATUSES.INACTIVE_REMOVED');

        const searchStrgSubscription = this.searchString.valueChanges
            .pipe(debounceTime(400), distinctUntilChanged())
            .subscribe((res: string) => {
                this.filterCustomers(res);
            });
        this.subscriptions.push(searchStrgSubscription);
    }

    public ngOnInit() {
        this.domOperationUtilsService.locationFiltersOn.next(this.displayFilters);
        this.subscriptions.push(this.domOperationUtilsService.locationFiltersOn.subscribe((v: boolean) => {
            this.displayFilters = v;
            this.uiUtilsService.safeChangeDetection(this.cdr);
        }));
        this.monitorSeriesList = [
            { monitorSeriesID: MonitorIdentifier.RainAlertIII, value: '', text: this.allTest },
            { monitorSeriesID: MonitorIdentifier.TritonPlus, value: 'TRITON+', text: this.tritonTest },
            { monitorSeriesID: MonitorIdentifier.Echo, value: 'ECHO', text: this.echoTest },
            { monitorSeriesID: MonitorIdentifier.RainAlertIII, value: 'RainAlert III', text: this.rainTest },
            { monitorSeriesID: MonitorIdentifier.USGS, value: 'USGS', text: this.usgsTest },
        ];

        this.activeInactiveList = [
            { value: true, text: this.activeTest },
            { value: '', text: this.allTest },
            { value: false, text: this.inActiveTest },
        ];
        this.wdoList = [
            { value: '', text: this.allTest },
            { value: 'N/A', text: this.naTest },
            { value: 'No', text: this.noTest },
            { value: 'Yes', text: this.yesTest },
        ];
        this.compositeList = [
            { value: 'Yes', text: this.yesTest },
            { value: 'No', text: this.noTest },
            { value: '', text: this.allTest },
        ];
        this.totalPaginationLength = 0;
        this.isSearchActive = false;
        this.subscriptions.push(
            this.statusCodeService.customerIdEdited.pipe(distinctUntilChanged()).subscribe((customerID: number) => {
                this.cid = customerID;
            }),
        );
        // create a table model, otherwise render may fail
        this.locationDataSourceNew = new FilterDataSource(
            this.locationDataChange,
            [],
            this.userPaginator,
            this.customerSort,
            this.locationFilterColumns,
        );
        const customerContextSubscription = combineLatest([
            this.statusCodeService.addNewCustomer,
            this.route.queryParamMap,
        ]).pipe(
            map(([addNewCustomerFlag, params]: [boolean, ParamMap]) => ({
                customerId: Number(params.get(addNewCustomerFlag ? customerQueryParam : customerEditorQueryParam)),
                includeInactiveLocations: Boolean(Number(params.get(activeInactiveLocationQueryParam))),
            })),
            distinctUntilChanged((previous, current) => previous.customerId === current.customerId
                && previous.includeInactiveLocations === current.includeInactiveLocations),
            tap((context) => {
                if (this.customerId !== context.customerId) {
                    this.rainGaugesList = [];
                    this.availableRainGauges = [];
                    this.assignedRainGauge = [];
                    this.locationGroupsFlat = undefined;
                }
                this.customerId = context.customerId;
                this.includeInactiveLocations = context.includeInactiveLocations;
                if (this.customerId > 0) {
                    this.getAllLocations(this.customerId);
                }
            }),
            map((context) => context.customerId),
            distinctUntilChanged(),
            switchMap((customerId: number) => customerId > 0 ? this.getRainGaugesData(customerId) : of<RainLocation[]>([])),
        ).subscribe((rainGauges: RainLocation[]) => {
            this.rainGaugesList = rainGauges;
            this.availableRainGauges = rainGauges.filter((gauge: RainLocation) => rainAlertIds.includes(gauge.seriesID));
            this.uiUtilsService.safeChangeDetection(this.cdr);
        });
        this.subscriptions.push(customerContextSubscription);

    }

    /**
     * Method brings up a pop up window with locations options
     * @param customAlarm - the customAlarm data object.
     */
    private getRainGaugesData(customerId: number): Observable<RainLocation[]> {
        // Create parameters object for getAllRainGauges method
        const parameters: GetAllRainGaugesParams = {
            CID: customerId,
            IncludeInactiveLocations: false,
            IType: RAIN_GAUGE,
            PageSize: 1000,
            StartPage: 1,
        };
        // get all rain gauge ids for that location
        return this.customerService.getAllRainGauges(parameters).pipe(
            map((response: RainLocation[] | null) => {
                const gaugesById = new Map<number, RainLocation>();
                for (const gauge of response ?? []) {
                    if (!gaugesById.has(gauge.locationId)) {
                        gaugesById.set(gauge.locationId, gauge);
                    }
                }
                return Array.from(gaugesById.values());
            }),
            catchError(() => of<RainLocation[]>([])),
        );
    }

    public addCompositeLocation(): void {
        if (!this.usersService.isMonitorEditor.getValue()) {
            return;
        }

        const data: CompositeLocCreateInput = { customerId: this.customerId };
        const dialogOptions: MatDialogConfig<CompositeLocComponentInput> = {
            disableClose: true,
            data,
        };

        if (this.gisService.locationCardPosition) {
            dialogOptions.position = this.locationCardService.checkLocationCardPosition(false, this.gisService.locationCardPosition);
        }

        this.dialog
            .open<CompositeLocComponent, CompositeLocComponentInput, IComponentModalResult>(
                CompositeLocComponent,
                dialogOptions,
            )
            .afterClosed()
            .subscribe((res) => {
                if (res.success) {
                    // if user add new location successfully, then refresh map.
                    this.getAllLocations(this.customerId);
                    this.resetFilters();
                }
            });
    }
    public openWetDry(element) {
        this.dialog
            .open<LocationWetDryOverflowComponent, LocationWetDryOverflowComponentInput, IComponentModalResult>(LocationWetDryOverflowComponent, {
                disableClose: true,
                data: {
                    customerId: this.customerId,
                    overidecustomer: true,
                    rainGaugeList: this.availableRainGauges,
                    locationName: element.locationName,
                    locationId: element.locationId,
                },
            })
            .afterClosed()
            .subscribe((res) => {
                if (res.success) {
                    this.getAllLocations(this.customerId);
                }
            });
    }

    public editLocation(location: CustomerLocationDetail) {
        this.isLoading = true;
        this.uiUtilsService.safeChangeDetection(this.cdr);
        // condition added to to open Triton+ popup if series matches
        if (location && location.locationTypeID === 1) {
            this.mapService.getMarkerLocationDetails(location.locationId, this.customerId).subscribe(
                (result) => {
                    if (result) {
                        this.isLoading = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        const locationDetails: LocationDetails = {
                            series: result.series,
                            serialNumber: result.serialNumber,
                            status: result.status,
                            modem: result.modem,
                            description: result.description,
                            manholeAddress: result.manholeAddress,
                            coordinate: { latitude: result.latitude, longitude: result.longitude, elevation: 1 },
                            locationID: result.locationID,
                            locationName: result.locationName,
                            assignedRainGaugeLocationId: result.assignedRainGaugeLocationId,
                            installationHeight: result.height,
                            installationWidth: result.width,
                            installationType: result.installationType,
                            installationId: result.installationID,
                            depthUnit: result.depthUnit,
                            flowUnit: result.flowUnit,
                            locationType: result.components ? 3 : 1,
                            components: result.components,
                            installationShape: result.installationShape,
                            ipaddress: result.connectionString,
                            range: result.range,
                            capacity: result.capacity,
                            width: result.width,
                            installationShapeTypeID: result.installationShapeTypeID,
                            manholedepth: result.manholeDepth,
                            length: result.length,
                            breadth: result.breadth,
                            coefficient: result.coefficient,
                            assignedRainGaugeLocationName: result.assignedRainGaugeLocationName,
                            entries: result.entries,
                            lastCollectedDate: '',
                        };

                        const dialogOptions: MatDialogConfig = {
                            disableClose: true,
                            data: {
                                isFromCustomerEditor: true,
                                rainGaugeLocations: this.rainGaugesList,
                                customerId: this.customerId,
                                editMode: true,
                                locationDetails: locationDetails,
                            },
                        };

                        if (this.gisService.locationCardPosition) {
                            dialogOptions.position = this.locationCardService.checkLocationCardPosition(true, this.gisService.locationCardPosition);
                        }

                        if (this.mapService.addEditLocationDialog) {
                            this.mapService.addEditLocationDialog.close();
                        }

                        this.mapService.addEditLocationDialog = this.dialog.open(
                            LocationCardContainerDialogComponent,
                            dialogOptions,
                        );
                        this.mapService.addEditLocationDialog
                            .afterClosed()
                            .pipe(first())
                            .subscribe((result: boolean) => {
                                this.mapService.addEditLocationDialog = null;
                                if (result) {
                                    this.locationIdEdited = location.locationId;
                                    this.getAllLocations(this.customerId);
                                    this.uiUtilsService.safeChangeDetection(this.cdr);
                                }
                            });
                    }
                },
                (error) => {
                    this.isLoading = false;
                },
            );
            return;
        }
        if (location.locationTypeID === 3) {
            this.customerLocationService.getLocationSummary(this.customerId, this.includeInactiveLocations).subscribe((items) => {
                let locations = new Array<CustomerLocationDetail>();
                if (items) {
                    locations = items.listCutomerLocations;
                }
                this.mapService.getMarkerLocationDetails(location.locationId, this.customerId).subscribe(
                    (result) => {
                        if (result) {
                            this.isLoading = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            const locationDetails: LocationDetails = {
                                locationID: result.locationID,
                                locationName: result.locationName,
                                description: result.description,
                                manholeAddress: result.manholeAddress,
                                coordinate: { latitude: result.latitude, longitude: result.longitude, elevation: 1 },
                                status: result.status,
                                modem: result.modem,
                                series: result.series,
                                serialNumber: result.serialNumber,
                                ipaddress: result.ipaddress,
                                lastCollectedDate: undefined,
                                components: result.components,
                            };
                            const data: CompositeLocEditInput = {
                                customerId: this.customerId,
                                locationDetails,
                                locations,
                            };
                            const dialogOptions: MatDialogConfig<CompositeLocComponentInput> = {
                                disableClose: true,
                                data,
                            };

                            if (this.gisService.locationCardPosition) {
                                dialogOptions.position = this.locationCardService.checkLocationCardPosition(false, this.gisService.locationCardPosition);
                            }
                            this.dialog
                                .open<CompositeLocComponent, CompositeLocComponentInput, IComponentModalResult>(CompositeLocComponent, dialogOptions)
                                .afterClosed()
                                .subscribe((result) => {
                                    if (result.success) {
                                        this.locationIdEdited = location.locationId;
                                        this.getAllLocations(this.customerId);
                                        this.uiUtilsService.safeChangeDetection(this.cdr);
                                    }
                                });
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                    },
                );
            });
        } else {
            this.isLoading = false;
            // #48735 We do not handle locationType = 2
        }

        this.isLoading = false;
    }

    /**
     * Show Hide Filter
     */
    public showHideFilter() {
        this.displayFilters = !this.displayFilters;
        this.domOperationUtilsService.locationFiltersOn.next(this.displayFilters);
    }

    public getAllLocations(customerId: number) {
        this.isLoading = true;

        const locationsSubscription = combineLatest([
            this.locationGroupService.getLocationGroups(this.customerId),
            this.customerLocationService.getLocationSummary(customerId, this.includeInactiveLocations),
        ]).subscribe(
            ([locationGroups, locationData]) => {
                if (!this.locationGroupsFlat) {
                    if (locationGroups && locationGroups.locationGroups && locationGroups.locationGroups.length) {
                        this.locationGroupList = [];
                        const flatLocations = locationGroups.locationGroups.flatMap((x) => [
                            ...x.locations.map((l) => {
                                return {
                                    ...l,
                                    locationGroupID: x.locationGroupID,
                                    locationGroupName: x.name
                                };
                            }),
                        ]);

                        this.locationGroupsFlat = [];
                        flatLocations.forEach((x) => {
                            if (!this.locationGroupsFlat[x.locationID]) {
                                this.locationGroupsFlat[x.locationID] = [x.locationGroupName];
                            } else {
                                this.locationGroupsFlat[x.locationID].push(x.locationGroupName);
                            }
                        });

                        if (locationGroups) {
                            locationGroups.locationGroups.forEach((locationGroup: LocationGroup) => {
                                const locationGroupSelectorItem = {
                                    value: locationGroup.name,
                                    text: locationGroup.name,
                                };
                                this.locationGroupList.push(locationGroupSelectorItem);
                            });
                        }
                        const locationGroupSelectorItemAll = { value: '', text: 'All' };
                        this.locationGroupList.push(locationGroupSelectorItemAll);
                    } else {
                        this.locationGroupsFlat = [];
                        this.locationGroupList = [{ value: '', text: 'All' }];
                    }
                }

                if (locationData) {
                    this.isLoading = false;
                    this.customerLocations = locationData.listCutomerLocations
                        .map((x) => {
                            return {
                                ...x,
                                locationGroupName: this.locationGroupsFlat[x.locationId]
                                    ? this.locationGroupsFlat[x.locationId]
                                    : null,
                            };
                        })
                        .sort((a, b) =>
                            a.locationName && b.locationName
                                ? a.locationName.localeCompare(b.locationName)
                                : a.locationName
                                    ? 1
                                    : -1,
                        );
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.initialcustomerLocationsData = this.customerLocations;
                    if (this.isSearchActive) {
                        this.searchedcustomerLocationsData = this.getSearchResults(this.searchText);
                    }
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.applyFilters();
                    this.generateLocationTable();
                    this.setupRainGaugeLocations();
                    this.getSensorsList(locationData.listCutomerLocations);
                } else if (locationData == null) {
                    this.isLoading = false;
                    this.generateLocationTable();
                }
            },
            (error) => {
                this.isLoading = false;
            },
        );
        // get location groups

        this.subscriptions.push(locationsSubscription);
    }

    private getSensorsList(locationSensors: CustomerLocationDetail[]) {
        const uniqueSensors: string[] = [];
        locationSensors.forEach((element) => {
            if (element.sensors && element.sensors !== '') {
                const sensors = element.sensors.split(',');
                sensors.forEach((e) => {
                    uniqueSensors.push(e.trim());
                });
            }
        });
        this.sensorsList = uniqueSensors.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        });
    }

    /**
     * Method generates a table of api keys
     */
    public generateLocationTable() {
        this.isLoading = true;
        this.uiUtilsService.safeChangeDetection(this.cdr);
        this.customerSort.start = 'desc';
        this.locationDataSourceNew = null;
        this.locationDataChange = new BehaviorSubject<CustomerLocationDetail[]>([]);
        const locationCopiedData: CustomerLocationDetail[] = [];
        this.customerLocations.forEach((location: CustomerLocationDetail, index) => {
            location.highlight = false;
            if (this.locationIdEdited && this.locationIdEdited === location.locationId) {
                const pageIndex = index / this.userPaginator.pageSize;
                const finalPageIndex = +pageIndex.toString().split('.')[0];
                this.userPaginator.pageIndex = finalPageIndex;
                location.highlight = true;
            }

            const monitorSeries = MonitorSeries.find(a => a.value === location.monitorSeries);
            if(monitorSeries){
                location.monitorSeries = monitorSeries.text;
            }

            const data: CustomerLocationDetail = {
                locationId: location.locationId,
                locationName: location.locationName,
                monitorSeries: location.monitorSeries,
                serialNumber: location.serialNumber,
                description: location.description,
                sensors: location.sensors,
                locationGroupName: location.locationGroupName,
                status: location.status,
                wdo: location.wdo !== 'N/A' ? location.wdo : '',
                locationTypeID: location.locationTypeID,
                highlight: location.highlight,
            };
            locationCopiedData.push(data);
        });
        this.locationDataChange.next(locationCopiedData);
        this.locationDataSourceNew = new FilterDataSource(
            this.locationDataChange,
            this.customerLocations,
            this.userPaginator,
            this.customerSort,
            this.locationFilterColumns,
        );
        if (!this.locationIdEdited) {
            this.userPaginator.pageIndex = 0;
        }
        this.totalPaginationLength = this.customerLocations.length;
        this.isLoading = false;
        this.emitPaginationState();
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public applyPagination(page: PageEvent): void {
        this.userPaginator.pageIndex = page.pageIndex;
        this.userPaginator.pageSize = page.pageSize;
        this.userPaginator.page.emit(page);
        this.emitPaginationState();
    }

    private emitPaginationState(): void {
        this.paginationStateChange.emit({
            length: this.totalPaginationLength,
            pageIndex: this.userPaginator?.pageIndex ?? 0,
            pageSize: this.userPaginator?.pageSize ?? 10,
            pageSizeOptions: [10, 25, 100],
        });
    }

    public activeMonitor(location: CustomerLocationDetail) {
        if (location.monitorSeries.toLowerCase().indexOf('triton+') > -1) {
            this.editLocation(location);
            return;
        }

        this.isLoading = true;

        const customerId = this.customerId;
        let result: LocationDetails;
        const locationsSubscription = this.mapService
            .getMarkerLocationDetails(location.locationId, customerId)
            .subscribe(
                (response) => {
                    if (response) {
                        result = response;
                        this.isLoading = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);

                        this.dialog.open(MonitorSettingsComponent, {
                            disableClose: true,
                            data: {
                                customerId: customerId,
                                LocationName: result.locationName,
                                Description: result.description,
                                ManholeAddress: result.manholeAddress,
                                Latitude: result.coordinate ? result.coordinate.latitude : '',
                                Longitude: result.coordinate ? result.coordinate.latitude : '',
                                IsActiveLocation:
                                    result.status === LocationStatus.Active ||
                                    result.status === LocationStatus.Maintenance,
                                MonitorSeries: result.series,
                                SerialNumber: result.serialNumber,
                                IpAddress: result.ipaddress,
                                locationID: result.locationID,
                                instalationType: result.installationType,
                            },
                        });
                    }
                },
                (error) => {
                    this.isLoading = false;
                },
            );
        this.subscriptions.push(locationsSubscription);
    }

    public onChange(e: MatSlideToggleChange, locationDetail: CustomerLocationDetail) {
        this.isLoading = true;
        this.locationIdEdited = locationDetail.locationId;
        const editApiKeySubscription = this.customerLocationService
            .editLocation(this.customerId, locationDetail.locationId, e.checked)
            .subscribe(
                (response) => {
                    this.isLoading = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.getAllLocations(this.customerId);
                    if (response) {
                        this.snackBar.open(this.locationUpdateSuccess, this.dismissText, { duration: 10000 });
                    } else {
                        this.snackBar.open(this.locationUpdateError, this.dismissText);
                    }
                },
                () => {
                    this.isLoading = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                    this.generateLocationTable();
                },
            );

        this.subscriptions.push(editApiKeySubscription);
    }

    private setupRainGaugeLocations() {
        // check if rain guage locations are already filled and if so exit immediately
        if (this.assignedRainGauge && this.assignedRainGauge.length > 0) {
            return;
        }

        // check if locations exist
        if (this.customerLocations) {
            // make the filtered array for assignedRainGauge.
            this.assignedRainGauge = this.customerLocations.filter((location) => {
                if (
                    location &&
                    location.monitorSeries &&
                    location.monitorSeries.toLowerCase().indexOf('rainalert') > -1
                ) {
                    return location;
                }
            });
        }
    }

    /**
     * Method takes a sting as an argument and filters out customers whose names include the string
     * @param searchString - string to search for customer
     */

    public applyFilters() {
        if (this.isSearchActive) {
            this.customerLocations = this.searchedcustomerLocationsData;
        } else {
            this.customerLocations = this.initialcustomerLocationsData;
        }

        if (this.selectedMonitorSeries) {
            this.monitorSeriesChange();
        }
        if (this.selectedLocationGrp) {
            this.locationGrpChange();
        }
        if (this.selectedActiveLocation !== null) {
            this.filterCustomersForActiveLoc(this.selectedActiveLocation);
        }

        if (this.selectedwdo) {
            this.wdoListChange();
        }
        if (this.selectedComposite) {
            this.compositeListChange();
        }
        if (this.selectedSensors) {
            this.sensorsListChange();
        }
    }

    public filterCustomers(searchString: string): void {
        const normalizedSearch = searchString?.trim() ?? '';
        this.searchText = normalizedSearch;
        this.isSearchActive = normalizedSearch.length > 0;
        this.searchedcustomerLocationsData = this.isSearchActive ? this.getSearchResults(normalizedSearch) : [];

        if (this.userPaginator) {
            this.userPaginator.pageIndex = 0;
        }

        this.applyFilters();
        this.generateLocationTable();
    }

    private getSearchResults(searchString: string): CustomerLocationDetail[] {
        const normalizedSearch = searchString.toLowerCase();
        const uniqueLocations = new Map<number, CustomerLocationDetail>();

        this.initialcustomerLocationsData.forEach((location: CustomerLocationDetail) => {
            const locationNameMatches = location.locationName?.toLowerCase().includes(normalizedSearch) ?? false;
            const serialNumberMatches = location.serialNumber?.toLowerCase().includes(normalizedSearch) ?? false;

            if (locationNameMatches || serialNumberMatches) {
                uniqueLocations.set(location.locationId, location);
            }
        });

        return Array.from(uniqueLocations.values());
    }

    public filterCustomersForMonitor(searchString: string) {
        if (!searchString || searchString.trim() === '') {
            this.customerLocations = this.customerLocations;
        } else {
            searchString = searchString.trim();
            this.customerLocations = this.customerLocations.filter((x) =>
                x.monitorSeries && x.monitorSeries.toLowerCase().includes(searchString.toLowerCase()),
            );
            this.userPaginator.pageIndex = 0;
        }
        this.generateLocationTable();
    }

    public filterCustomersForActiveLoc(isActive: boolean) {
        if (isActive === undefined || isActive === null) {
            this.customerLocations = this.customerLocations;
        } else {
            this.customerLocations = this.customerLocations.filter((x) =>
                isActive
                    ? x.status === LocationStatus.Active || x.status === LocationStatus.Maintenance
                    : x.status === LocationStatus.Inactive || x.status === LocationStatus.InactiveRemoved,
            );
            this.userPaginator.pageIndex = 0;
        }

        this.generateLocationTable();
    }

    public monitorSeriesChange() {
        this.filterCustomersForMonitor(this.selectedMonitorSeries);
    }

    public compositeListChange() {
        if (!this.selectedComposite || this.selectedComposite.trim() === '') {
            this.customerLocations = this.customerLocations;
        } else {
            this.customerLocations =
                this.selectedComposite.toLowerCase() === 'yes'
                    ? this.customerLocations.filter((x) => x.locationTypeID !== 1)
                    : this.customerLocations.filter((x) => x.locationTypeID === 1);
            this.userPaginator.pageIndex = 0;
        }
        this.generateLocationTable();
    }
    public wdoListChange() {
        if (!this.selectedwdo || this.selectedwdo.trim() === '') {
            this.customerLocations = this.customerLocations;
        } else {
            this.customerLocations = this.customerLocations.filter((x) =>
                x.wdo.toLowerCase().includes(this.selectedwdo.toLowerCase()),
            );
            this.userPaginator.pageIndex = 0;
        }
        this.generateLocationTable();
    }

    private sensorsListChange() {
        if (this.selectedSensors[0] === '') {
            this.customerLocations = this.customerLocations;
        } else {
            this.selectedSensors.forEach((e) => {
                this.customerLocations = this.customerLocations.filter(
                    (x) => x.sensors && x.sensors.toLowerCase().includes(e.toLowerCase()),
                );
            });
        }
        this.userPaginator.pageIndex = 0;
        this.generateLocationTable();
    }

    public locationGrpChange() {
        if (!this.selectedLocationGrp || this.selectedLocationGrp.trim() === '') {
            this.customerLocations = this.customerLocations;
        } else {
            this.customerLocations = this.customerLocations.filter(
                (x) => {
                    if (!x.locationGroupName) return false;
                    if (x.locationGroupName instanceof Array) return x.locationGroupName.find(s => s.toLowerCase() === this.selectedLocationGrp.toLowerCase());
                    return x.locationGroupName.toLowerCase().includes(this.selectedLocationGrp.toLowerCase());
                }
            );
            this.userPaginator.pageIndex = 0;
        }
        this.generateLocationTable();
    }

    public resetFilters() {
        this.selectedMonitorSeries = null;
        this.selectedLocationGrp = null;
        this.selectedActiveLocation = null;
        this.selectedwdo = null;
    }

    public addTritonLocation(): void {
        if (!this.usersService.isMonitorEditor.getValue()) {
            return;
        }

        this.disableAddLocationBtn = true;

        const dialogOptions: MatDialogConfig<LocationCardData> = {
            disableClose: true,
            data: {
                isFromCustomerEditor: true,
                rainGaugeLocations: this.rainGaugesList,
                customerId: this.customerId,
                editMode: false,
            },
        };

        if (this.gisService.locationCardPosition) {
            dialogOptions.position = this.locationCardService.checkLocationCardPosition(true, this.gisService.locationCardPosition);
        }

        if (this.mapService.addEditLocationDialog) {
            this.mapService.addEditLocationDialog.close();
        }

        this.mapService.addEditLocationDialog = this.dialog.open<
            LocationCardContainerDialogComponent,
            LocationCardData,
            boolean
        >(LocationCardContainerDialogComponent, dialogOptions);
        this.mapService.addEditLocationDialog
            .afterClosed()
            .pipe(first())
            .subscribe((result: boolean) => {
                this.mapService.addEditLocationDialog = null;
                this.disableAddLocationBtn = false;
                if (result) {
                    this.getAllLocations(this.customerId);
                }
                this.uiUtilsService.safeChangeDetection(this.cdr);
            });
    }

    ngOnDestroy() {
        if (this.mapService.addEditLocationDialog) {
            this.mapService.addEditLocationDialog.close();
            this.mapService.addEditLocationDialog = null;
        }
        this.subscriptions.forEach((v) => v.unsubscribe());
    }
}
